export default __webpack_public_path__ + "static/media/yellowdonemark.3096511f.svg";